import {fetch} from '../utils/fetch'
import {casaApiUrl} from 'configs/casa-api'

function getTenantAuthToken() {
  return fetch(`${casaApiUrl}/users/tenant/auth_token`, {
    credentials: 'include',
    method: 'get'
  }).then(res => res.json())
}

function createRequestHandler(requestHandlerName) {
  // return if requestHandlerName has whitespace as it's not a valid name
  if (/\s/g.test(requestHandlerName)) {
    return
  }
  return fetch(`${casaApiUrl}/users/tenant/saveRequestHandler/${requestHandlerName}`, {
    credentials: 'include',
    method: 'post'
  }).then(res => res.json())
}

export default {
  getTenantAuthToken,
  createRequestHandler
}



// WEBPACK FOOTER //
// ./src/services/tenant-service.js